<template>
    <router-view/>
</template>

<script>
    export default {
        name: "Masa"
    }
</script>

<style scoped>

</style>